// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { DealerConfigSettings } from './settings.interfaces';

export interface DealerData {
    count: number;
    dealers: Dealer[];
}
export interface Dealer {
    dealerId: number;
    name: string;
    logo: string;
    logoUrl: string;
    domain: string;
    address: string;
    city: string;
    state: string;
    postalCode: string;
    phoneNumber: string;
    faxNumber: string;
    checkForInventory: boolean;
    file: any;
    oemCode: string;
    oemName: string;
    oemDealerId: string;
    OEMDealerID: string;
    nameOverride: string;
    phoneNumberOverride: string;
    faxNumberOverride: string;
    onboardingDate: Date;
    startBillingDate: Date;
    printerSetupCompleteDate: Date;
    formsReceivedDate: Date;
    formsLoadedDate: Date;
    trainingCompleteDate: Date;
    goNoGoDate: Date;
    goLiveDate: Date;
    goLiveSignOffDate: Date;
    terminationDate: Date;
    turnOffAccessDate: Date;
    dealerActivatorId: number;
    //These need to get moved to dealer settings
    signingPreference: string;
    sendToCRM: boolean;
    isTestDealer: boolean;

    autoGroupId: number;
    autoGroupName: string;

    //Enrollment Based
    baseEnrollmentDate: Date;
    baseActivationDate: Date;
    baseTerminationDate: Date;
    baseTurnOffAccessDate: Date;
    unlimitedEnrollmentDate: Date;
    unlimitedActivationDate: Date;
    unlimitedTerminationDate: Date;
    unlimitedTurnOffAccessDate: Date;
    campaignEnrollmentDate: Date;
    campaignActivationDate: Date;
    campaignTerminationDate: Date;
    campaignTurnOffAccessDate: Date;
    testDriveEnrollmentDate: Date;
    testDriveActivationDate: Date;
    testDriveTerminationDate: Date;
    testDriveTurnOffAccessDate: Date;
    apptScheduledEnrollmentDate: Date;
    apptScheduledActivationDate: Date;
    apptScheduledTerminationDate: Date;
    apptScheduledTurnOffAccessDate: Date;
}

export enum DealerStatus {
    Active = 1,
    Inactive = 2,
    NeverEnrolled = 3,
}

export enum DealerId {
    Customer = -1,
    Internal = 0,
}

export enum SigningQueuePreference {
    bdc = 'BCD',
    dbc = 'DBC',
}

export enum Features {
    RouteOne = 'RouteOne',
    Notarize = 'Notarize',
    DealerCanSignOutOfQueue = 'DealerCanSignOutOfQueue',
    SignPdfKeepFields = 'SignPdfKeepFields',
    ApiSigningServiceV2 = 'SigningServiceV2',
}

export enum DealerProducts {
    EzDocsBase = 1,
    EzDocsAutomate = 2, //Print to DDJ
    Notarize = 3,
    DriverLicenseScan = 4,
    Training = 5,
    RouteOne = 6,
}

export interface DealerProductEnrollments {
    enableEdit: boolean;
    dealerId: number;
    productId: DealerProducts;
    productName: string;
    units: number;
    vendorDealerId?: string;
    enrollmentDate: Date;
    activationDate: Date;
    terminationDate: Date;
    turnOffAccessDate: Date;
    createDate: Date;
    createdBy: number;
    createdByName: string;
    lastUpdateDate: Date;
    lastUpdateBy: string;
    lastUpdateByName: string;
    lastUpdateByIPAddress: string;
    terminationReason: string;
    productPrice: number;
    productFrequency: string;
    isActive: boolean;
    usersName: any;
    overrideLimit: number;
    currentMonthScans?: number;
}

export interface DealerOemCode {
    oemCode: string;
    oemName: string;
    active: boolean;
}

export interface DealerAutoGroup {
    autoGroupId: number;
    autoGroupName: string;
    description: string;
}

export interface DealerSettings {
    dealerId: number;
    dealerConfigSettingId: DealerConfigSettings;
    settingName: string;
    settingValue: string;
    dataTypeId: number;
    isInternal: boolean;
    createdBy: number;
    createDate: Date;
    lastUpdateBy: number;
    lastUpdateDate: Date;
}

export interface TestDriveSettings {
    dealerId?: number;
    headerImage?: string;
    atHome?: boolean;
    atOther?: boolean;
    allowSameDayTestDrive?: boolean;
    mondayAvailable?: boolean;
    tuesdayAvailable?: boolean;
    wednesdayAvailable?: boolean;
    thursdayAvailable?: boolean;
    fridayAvailable?: boolean;
    saturdayAvailable?: boolean;
    sundayAvailable?: boolean;
    mondayStartTime?: string;
    mondayEndTime?: string;
    tuesdayStartTime?: string;
    tuesdayEndTime?: string;
    wednesdayStartTime?: string;
    wednesdayEndTime?: string;
    thursdayStartTime?: string;
    thursdayEndTime?: string;
    fridayStartTime?: string;
    fridayEndTime?: string;
    saturdayStartTime?: string;
    saturdayEndTime?: string;
    sundayStartTime?: string;
    sundayEndTime?: string;
    file?: any;
}
